import { render, staticRenderFns } from "./PublicacionPreview.vue?vue&type=template&id=10b5c2ad&scoped=true"
import script from "./PublicacionPreview.vue?vue&type=script&lang=ts"
export * from "./PublicacionPreview.vue?vue&type=script&lang=ts"
import style1 from "./PublicacionPreview.vue?vue&type=style&index=1&id=10b5c2ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b5c2ad",
  null
  
)

export default component.exports